<template>
  <div>

    <div class="wrapper">
      <app-sidebar></app-sidebar>
      <div class="main-panel" style="height: 100vh;">
        <app-navbar></app-navbar>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
        
      </div>

    </div>

  </div>
</template>



<script>
  import Sidebar from "./shared/Sidebar"
  import Navbar from "./shared/Navbar"
  import Footer from "./shared/Footer"
  

  export default {
    components  : {
      appSidebar : Sidebar,
      appNavbar : Navbar,
      appFooter : Footer,
    },
    created(){
      this.$store.dispatch("initApp")
      this.$store.dispatch("initStudent")
      this.$store.dispatch("initCompany")

    },
    data (){
      return {
        
      }
    },
  }
</script>


<style>
  .fade-enter{
    opacity: 0;
  }
  .fade-enter-active{
    transition: opacity .3s ease-out;
  }

  .fade-leave-active{
    transition: opacity .3s ease-out;
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue